module.exports = __webpack_public_path__ + "static/media/signupleft.4ba5489c.png";